import gql from 'graphql-tag';

export const RecommendedGlobalJobTagsFragment = gql`
  fragment RecommendedGlobalJobTagsFragment on RecommendedGlobalJob {
    id
    tags {
      type
      label(locale: $locale)
    }
  }
`;
export const CareerFeedJobBadgesFragment = gql`
  fragment CareerFeedJobBadgesFragment on CareerFeedJob {
    id
    jobId
    jobBadges(
      locale: $locale
      visitorId: $visitorId
      platform: WEB
      channel: HOME
    ) {
      badgeDetails {
        badge
        displayText
      }
    }
  }
`;
